import classNames from "classnames";

export const Error = ({message, className = '', variant = 'site'}) => {
    return message ? <p className={classNames(`formError`, `formError--${variant}`, className)}>{message}</p> : null;
}
